import Vue from 'vue'
import Router from 'vue-router'

import sessionStorageUtil from '@/api/sessionStorageUtil'
import cookieUtil from '@/api/cookieUtil'
import {
  getTokenExp,
  interceptOldWeb2NewWebSetParam,
  getOldWebUrl
} from '@/api/base'
import {
  SelectSales,
  PopupFrame,
  CommonFrame,
  VisaProduct,
  VisaRouteInfo,
  VisaInterviewDate,
  MoreRegion,
  ViewSampleImg,
  MsgList,
  InvoiceAppAffirm,
  InvoiceAppInfo,
  InvoiceList,
  InvoiceAppSucceed

} from '@/pages/common'
import {
  UserFrame,
  Login,
  SmsLogin,
  Regist,
  Regist2,
  FindPasswd,
  FindPasswd2,
  FindPasswd3
} from '@/pages/user'
import {
  AgentFrame,
  AgentLogin,
  AgentOrderList,
  AgentOrderDetail,
  AOrderSubmit,
  ARouteOrderResult,
  OrderReceive,
  OrderReceiveResult,
  PersonalData,
  ACenterFrame,
  CustomList,
  RouteOrderEdit,
  RouteOrderNameList
} from '@/pages/agent'
import {
  CustomerFrame,
  OrderSubmit,
  OrderList,
  CustomerOrderDetail,
  BookingInformation,
  RouteOrderResult,
  CenterFrame,
  AgentInfos,
  MemberInfo,
  EditPhone,
  EditPhone2,
  EditPassword,
} from '@/pages/customer'
import {
  PayFrame,
  PayOrder,
  PayResult,
  PayWeixin,
  PayWeixinWait
} from '@/pages/pay'

Vue.use(Router)

const routes = [

  {
    path: '',
    redirect: '/common/visaproduct'
  },

  //公共组件
  {
    path: '/common',
    component: CommonFrame,
    name: 'common',
    children: [
      //公共界面
      {
        path: 'visaproduct',
        name: 'visaProduct',
        component: VisaProduct,
        meta: { title: '签证产品' }
      },
      {
        path: 'visaRouteInfo',
        name: 'visaRouteInfo',
        component: VisaRouteInfo,
        meta: { title: '签证产品详情' }
      },
      {
        path: 'findPasswd',
        name: 'findPasswd',
        component: FindPasswd,
        meta: { title: '找回密码' }
      },
      {
        path: 'findPasswd2',
        name: 'findPasswd2',
        component: FindPasswd2,
        meta: { title: '安全验证' }
      },
      {
        path: 'findPasswd3',
        name: 'findPasswd3',
        component: FindPasswd3,
        meta: { title: '设置密码' }
      },

      //user界面（用户登陆、注册等）
      {
        path: '/user',
        component: UserFrame,
        meta: { title: '用户' },
        children: [
          { path: '', redirect: 'login' },
          {
            path: 'login',
            name: 'login',
            component: Login,
            meta: { title: '会员登陆' }
          },
          {
            path: 'smsLogin',
            name: 'smsLogin',
            component: SmsLogin,
            meta: { title: '游客登陆' }
          },
          {
            path: 'regist',
            name: 'regist',
            component: Regist,
            meta: { title: '会员注册' }
          },
          {
            path: 'regist2',
            name: 'regist2',
            component: Regist2,
            meta: { title: '会员注册' }
          }
        ]
      },

      // 客户端
      {
        path: '/customer',
        component: CustomerFrame,
        meta: { title: '客户下单' },
        children: [
          {
            path: 'center',
            name: 'centerFrame',
            component: CenterFrame,
            meta: { title: '我的资料' },
            children: [
              { path: '', redirect: 'memberInfo' },
              {
                path: 'orderList',
                name: 'orderList',
                component: OrderList,
                meta: { title: '我的订单' }
              },
              {
                path: 'agentInfos',
                name: 'agentInfos',
                component: AgentInfos,
                meta: { title: '我的销售' }
              },
              {
                path: 'memberInfo',
                name: 'memberInfo',
                component: MemberInfo,
                meta: { title: '我的资料' }
              },
              {
                path: 'editPhone',
                name: 'editPhone',
                component: EditPhone,
                meta: { title: '验证身份' }
              },
              {
                path: 'editPhone2',
                name: 'editPhone2',
                component: EditPhone2,
                meta: { title: '验证新手机号' }
              },
              {
                path: 'editPassword',
                name: 'editPassword',
                component: EditPassword,
                meta: { title: '验证新手机号' }
              },
              {
                path: 'msgList',
                name: 'msgList',
                component: MsgList,
                meta: { title: '我的消息' }
              },
            ]
          },
          {
            path: 'orderSubmit',
            name: 'orderSubmit',
            component: OrderSubmit,
            meta: { title: '提交订单' }
          },
          {
            path: 'orderDetail',
            name: 'customerOrderDetail',
            component: CustomerOrderDetail,
            meta: { title: '订单详情' }
          },
          {
            path: 'route/routeOrderResult',
            name: 'routeOrderResult',
            component: RouteOrderResult,
            meta: { title: '下订单结果' }
          }
        ]
      },

      //销售
      {
        path: '/agent',
        component: AgentFrame,
        meta: { title: '销售' },
        children: [
          { path: '', redirect: 'agentLogin' },
          {
            path: 'center',
            name: 'aCenterFrame',
            component: ACenterFrame,
            meta: { title: '我的资料' },
            children: [
              { path: '', redirect: 'personalData' },
              {
                path: 'orderList',
                name: 'agentOrderList',
                component: AgentOrderList,
                meta: { title: '我的订单-销售' }
              },
              {
                path: 'personalData',
                name: 'personalData',
                component: PersonalData,
                meta: { title: '我的资料' }
              },
              {
                path: 'msgList',
                name: 'aMsgList',
                component: MsgList,
                meta: { title: '我的消息' }
              },
              {
                path: 'customList',
                name: 'customList',
                component: CustomList,
                meta: { title: '销售信息' }
              }
            ]
          },
          {
            path: 'agentLogin',
            name: 'agentLogin',
            component: AgentLogin,
            meta: { title: '销售登陆' }
          },
          {
            path: 'orderDetail',
            name: 'agentOrderDetail',
            component: AgentOrderDetail,
            meta: { title: '订单详情-销售' }
          },
          {
            path: 'aOrderSubmit',
            name: 'aOrderSubmit',
            component: AOrderSubmit,
            meta: { title: '提交订单-销售' }
          },
          {
            path: 'route/aRouteOrderResult',
            name: 'aRouteOrderResult',
            component: ARouteOrderResult,
            meta: { title: '下订单结果-销售' }
          },
          {
            path: 'orderReceive',
            name: 'orderReceive',
            component: OrderReceive,
            meta: { title: '订单收款' }
          },
          {
            path: 'orderReceiveResult',
            name: 'orderReceiveResult',
            component: OrderReceiveResult,
            meta: { title: '收款结果' }
          },
          {
            path: 'route/routeOrderEdit',
            name: 'routeOrderEdit',
            component: RouteOrderEdit,
            meta: { title: '订单编辑' }
          },
          {
            // 编辑订单和下订单的编辑办签人不一样
            path: 'route/routeOrderNameList',
            name: 'routeOrderNameList',
            component: RouteOrderNameList,
            meta: { title: '更新办签人' }
          }
        ]
      },

      //支付
      {
        path: '/pay',
        component: PayFrame,
        meta: { title: '支付' },
        children: [
          { path: '', redirect: 'payOrder' },
          {
            path: 'payOrder',
            name: 'payOrder',
            component: PayOrder,
            meta: { title: '订单支付' }
          },

          {
            path: 'payResult',
            name: 'payResult',
            component: PayResult,
            meta: { title: '订单支付结果' }
          },
          {
            path: 'payWeixin',
            name: 'payWeixin',
            component: PayWeixin,
            meta: { title: '微信支付' }
          },
          {
            path: 'payWeixinWait',
            name: 'payWeixinWait',
            component: PayWeixinWait,
            meta: { title: '等待微信支付结果' }
          }
        ]
      }
    ]
  },
  //弹窗类型
  {
    path: '/popup',
    component: PopupFrame,
    children: [
      // { path: '', redirect: 'customer/visaIndex' },
      {
        path: 'selectSales',
        name: 'selectSales',
        component: SelectSales,
        meta: { title: '选择销售客服' }
      },
      {
        path: 'route/bookingInformation',
        name: 'bookingInformation',
        component: BookingInformation,
        meta: { title: '预订须知' }
      },
      {
        path: 'visaInterviewDate',
        name: 'visaInterviewDate',
        component: VisaInterviewDate,
        meta: { title: '可预约面试时间' }
      },
      {
        path: 'moreRegion',
        name: 'moreRegion',
        component: MoreRegion,
        meta: { title: '签证国家/地区' }
      },
      {
        path: 'viewSampleImg',
        name: 'viewSampleImg',
        component: ViewSampleImg,
        meta: { title: '查看样图' }
      },
      {
        path: 'invoiceAppAffirm',
        name: 'invoiceAppAffirm',
        component: InvoiceAppAffirm,
        meta: { title: '发票信息' }
      },
      {
        path: 'invoiceAppInfo',
        name: 'invoiceAppInfo',
        component: InvoiceAppInfo,
        meta: { title: '发票申请' }
      },
      {
        path: 'invoiceList',
        name: 'invoiceList',
        component: InvoiceList,
        meta: { title: '发票详情' }
      },
      {
        path: 'invoiceSucceed',
        name: 'invoiceSucceed',
        components: InvoiceAppSucceed,
        meta: {title: '发票提交成功'}
      }
    ]
  }
]

const vueRouter = new Router({
  //base: __dirname,
  mode: 'history', //启用浏览器的历史记录
  // mode:"hash",
  base: process.env.FRONT_BASE_URL,
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes
})
//路由拦截列表
const domainInterceptRoutes = [
  'login',
  'smsLogin',
  'regist',
  'regist2',
  'findPasswd',
  'findPasswd2',
  'findPasswd3'
] //2级域名才能访问的页面
//会员登陆才能访问的页面(组件名称)
const memberInterceptRoutes = [
  'memberInfo',
  'orderList',
  'customerOrderDetail',
  'dataReview',
  'dataUpload',
  'agentInfos',
  'editPhone',
  'editPhone2',
  'editPassword',
  'routeOrderResult',
  'msgList'
]
//销售登陆才能访问的页面(组件名称)
const agentInterceptRoutes = [
  'personalData',
  'agentOrderList',
  'agentOrderDetail',
  'aMsgList',
  'customList',
  'routeOrderEdit',
  'orderReceive',
  'orderReceiveResult',
  'routeOrderNameList',
  'aRouteOrderResult',
  'aOrderSubmit',
  'customerInfo'
]
const forntParamTitle = ['visaRouteList'] //页面标题根据参数设置
const forntParamTitleParamName = { visaRouteList: 'relative_city' } //页面标题根据参数设置时的参数名，key：页面name，value：参数name
/* beforeEach  钩子实现导航守卫
 to: Route: 即将要进入的目标 路由对象
 from: Route: 当前导航正要离开的路由
 next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数
    next(): 进行管道中的下一个钩子。如果全部钩子执行完了，则导航的状态就是 confirmed （确认的）。
    next(false): 中断当前的导航。如果浏览器的 URL 改变了（可能是用户手动或者浏览器后退按钮），那么 URL 地址会重置到 from 路由对应的地址。
    next('/') 或者 next({ path: '/' }): 跳转到一个不同的地址。当前的导航被中断，然后进行一个新的导航。
    next(error): (2.4.0+) 如果传入 next 的参数是一个 Error 实例，则导航会被终止且该错误会被传递给 router.onError() 注册过的回调 */
vueRouter.beforeEach(function(to, from, next) {
  if (to.meta.title) {
    if (forntParamTitle.indexOf(to.name) >= 0) {
      document.title =
        to.query[forntParamTitleParamName[to.name]] + to.meta.title
    } else {
      //如果设置标题，拦截后设置标题
      document.title = to.meta.title
    }
  } else {
    document.title = '华侨城旅游网站'
  }
  let token = sessionStorageUtil.get('token')
  let username = sessionStorageUtil.get('username')
  let agent_username = sessionStorageUtil.get('agent_username')
  let web_type = sessionStorageUtil.get('web_type')
  if (!token && cookieUtil.get('new_token')) {
    token = cookieUtil.get('new_token')
    username = cookieUtil.get('new_username')
    agent_username = cookieUtil.get('new_agent_username')
    web_type = cookieUtil.get('new_web_type')
  }
  if (domainInterceptRoutes.indexOf(to.name) >= 0) {
    //2级域名拦截
    if (web_type != 2) {
      interceptOldWeb2NewWebSetParam(to.query) //路由被拦截后设置参数
      let web_type2 = sessionStorageUtil.get('web_type')
      if (web_type2 == 2) {
        next()
      } else {
        window.location.href = getOldWebUrl() + 'tourism/network.jsp'
      }
    } else {
      next()
    }
  } else if (agentInterceptRoutes.indexOf(to.name) >= 0) {
    //销售登陆拦截
    if (
      token == null ||
      token == '' ||
      agent_username == null ||
      agent_username == '' ||
      getTokenExp(token) < 0
    ) {
      interceptOldWeb2NewWebSetParam(to.query) //路由被拦截后设置参数
      sessionStorageUtil.set('next_message', '请先用销售账号登陆!', 60 * 1)
      next({
        name: 'agentLogin',
        //to.fullPath:要跳转页面的路径(带参数)
        //to.path：要跳转页面的路径(不带参数)
        query: { to_fullPath: to.fullPath, to_path: to.path }
      })
    } else {
      next()
    }
  } else if (memberInterceptRoutes.indexOf(to.name) >= 0) {
    //会员登陆拦截
    if (
      token == null ||
      token == '' ||
      username == null ||
      username == '' ||
      getTokenExp(token) < 0
    ) {
      interceptOldWeb2NewWebSetParam(to.query) //路由被拦截后设置参数
      sessionStorageUtil.set('next_message', '请先用会员账号登陆!', 60 * 1)
      next({
        name: 'login',
        //to.fullPath:要跳转页面的路径(带参数)
        //to.path：要跳转页面的路径(不带参数)
        query: { to_fullPath: to.fullPath, to_path: to.path }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js